module.exports = __webpack_public_path__ + "img/membership-settings.c4617050.svg";